import $ from 'jquery';

const NACTIVE = 'not-active';
const ACTIVE = 'active';
const product = function product() {
  const $win = $(window);
  const productScroll = $('.product-scroll');

  if (productScroll.length) {
    $win.on('load resize', () => {
      if ($win.width() >= 768) {
        setTimeout(() => {
          const customHeight =
            $win.height() -
            121 -
            $('.product--title-lined__no-top').offset().top -
            $('.product__bottom').height();

          if (customHeight < 250) {
            productScroll.height(250);
          } else {
            productScroll.height(customHeight);
          }
        }, 300);
      }
    });
  }

  const productBtn = $('.product-link');
  const allProductDetails = $('.product-details');
  const productDetailsWrapper = $('.product-image');
  if (productBtn && productBtn.length) {
    productBtn.click(ev => {
      const $self = $(ev.target);
      if ($self.hasClass(ACTIVE)) {
        productBtn.removeClass(NACTIVE).removeClass(ACTIVE);
        allProductDetails.removeClass(ACTIVE);
        setTimeout(() => {
          productDetailsWrapper.removeClass('active');
        }, 350);
      } else {
        productDetailsWrapper.addClass('active');
        productBtn.removeClass(ACTIVE).addClass(NACTIVE);
        $self.removeClass(NACTIVE).addClass(ACTIVE);

        const productDetails = $($self.data('content'));
        if (productDetails && productDetails.length) {
          allProductDetails.removeClass(ACTIVE);
          setTimeout(() => {
            productDetails.addClass(ACTIVE);
          }, 350);
        }
      }
    });
  }

  const closeProduct = $('.product-details__close');
  if (closeProduct && closeProduct.length) {
    closeProduct.click(() => {
      productBtn.removeClass(NACTIVE).removeClass(ACTIVE);
      allProductDetails.removeClass(ACTIVE);
      setTimeout(() => {
        productDetailsWrapper.removeClass('active');
      }, 350);
    });
  }
};
export default product;



// WEBPACK FOOTER //
// ./src/scripts/modules/product.js